export default "__VITE_ASSET__5gAyx31N__"